import apiClient from "../client";

export interface CurrentUser {
  pk: number;
  email: string;
  uuid: string;
  role: string;
  tier: string;
}

export const getCurrentUser = () =>
  apiClient.get<CurrentUser>("/api/auth/user/").then((r) => r.data);

export const logout = () => apiClient.post("/api/auth/logout/");

export const deleteAccount = () =>
  apiClient.post("/api/account/delete/", { confirm: "DELETE MY ACCOUNT" });
